<template>
	<article class="expertise">
		<h1>Projects</h1>
		<div class="content">
			<view-portfolio :data="projects" :itemsPerPage="itemsPerPage"></view-portfolio>
		</div>
	</article>
</template>

<script>
	import viewPortfolio from '../views/viewPortfolio'
	export default {
		name: 'projects',
		components: {
			viewPortfolio
		},
		data () {
			return {
				currentPage: 0,
				itemsPerPage: 6,
				projects: [
					{ name: 'beithakochav', image: 'static/images/projects/bh.jpg', caption: 'Beit Hakochav', desc: 'Website', link: 'http://www.goodogs.com' },
					{ name: 'audion', image: 'static/images/projects/audion.jpg', caption: 'AudioClinic Nataly', desc: 'Website', link: 'http://www.audion.co.il' }
//					{ name: 'ics', image: 'static/images/projects/audion.jpg', caption: ' ICS', 'desc': 'Web Design', link: 'http://www.israeldc.com/he' }
				]
			}
		}
	}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// projects.vue?14bcda99